import componentHelper from '../../modules/component_helper.js';

angular.module('vastdesk').
  component('demandTagActive',  {
    bindings: {
      formName: '@',
      formId: '@',
      isActive: '<',
      sequentialLiabilityApproved: '<'
    },
    template: require("../templates/demandTagActive.html"),
    controllerAs: '$demandTagActiveCtrl',
    controller: ['$scope','$rootScope', function($scope, $rootScope) {

      var self = this;
      this.statusOptions = componentHelper.statusOptions();
      this.campaignActive = true;

      $rootScope.$on('campaignActiveChange', function(e, args) {
        self.campaignActive = args.campaignActive;
      });

      $rootScope.$on('sequentialLiabilityChange', function(e, args) {
        self.sequentialLiabilityApproved = args.approved;
        if (!self.sequentialLiabilityApproved) {
          self.isActive = false;
        }
      });

      this.setStatus = function(status) {
        if (!self.sequentialLiabilityApproved) {
          self.isActive = false;
        } else {
          self.isActive = status;
        }
      };

    }]
});